import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LangService {

    constructor(
        private translate: TranslateService,
        private location: Location
    ) { }

    private allowedLangs: string[] = ['sv', 'en'];
    private defaultLang = "sv";

    public init(allowedLangs = []): void {
        if (allowedLangs.length > 0) this.allowedLangs = allowedLangs;

        let langCode: string;
        
        //Ändra språk efter ev. språk i url
        let urlLang = this.location.path().split('/')[1];
        let urlContainsLang = urlLang && urlLang.length == 2;
        
        if (urlContainsLang && 
            urlLang != this.defaultLang && 
            this.langIsAllowed(urlLang))     
        {
            langCode = urlLang;
        }

        if (!langCode) {
            let browserLang = this.translate.getBrowserLang();
            if (this.allowedLangs.indexOf(browserLang) >= 0) {
                langCode = browserLang;
                if (urlLang != langCode) {
                    //Om browsers språk inte är detsamma som språket i url:en => Ändra språket i url:en
                    //Ta bort språk från path för att sedan lägga till webbläsarens inställda språk
                    let path = this.location.path();
                    if (urlContainsLang) path = path.substr(3);
                    if (path == "") path = "/home";
                    let modifiedPath = '/' + langCode + path;
                    this.location.go(modifiedPath);
                }
            }
        }

        langCode = langCode ?? this.defaultLang;

        this.translate.addLangs(this.allowedLangs);
        this.translate.setFallbackLang(langCode);
        this.changeLanguage(langCode);
    }

    public static readonly currentLang = new BehaviorSubject<string>('sv');

    public changeLanguage(language: string) {
        if (this.langIsAllowed(language))
        {
            this.translate.use(language);
            LangService.currentLang.next(language);
        }        
    }

    private langIsAllowed(language: string): boolean {
        return this.allowedLangs.indexOf(language) > -1;
    }
}
